import listActions from '../../../modules/playlistSong/list/playlistSongListActions'
import PlaylistSongService from '../../../modules/playlistSong/playlistSongService'
import Errors from '../../../modules/shared/error/errors'
import { i18n } from '../../../i18n'
import { push } from 'redux-first-history'
import Message from '../../../view/shared/message'

const prefix = 'PLAYLISTSONG_DESTROY'

const playlistSongDestroyActions = {
  DESTROY_STARTED: `${prefix}_DESTROY_STARTED`,
  DESTROY_SUCCESS: `${prefix}_DESTROY_SUCCESS`,
  DESTROY_ERROR: `${prefix}_DESTROY_ERROR`,

  DESTROY_ALL_STARTED: `${prefix}_DESTROY_ALL_STARTED`,
  DESTROY_ALL_SUCCESS: `${prefix}_DESTROY_ALL_SUCCESS`,
  DESTROY_ALL_ERROR: `${prefix}_DESTROY_ALL_ERROR`,

  doDestroy: (id) => async (dispatch) => {
    try {
      dispatch({
        type: playlistSongDestroyActions.DESTROY_STARTED,
      })

      await PlaylistSongService.destroyAll([id])

      dispatch({
        type: playlistSongDestroyActions.DESTROY_SUCCESS,
      })

      Message.success(
        i18n('entities.playlistSong.destroy.success'),
      )

      dispatch(listActions.doFetchCurrentFilter())

      dispatch(push('/playlist-song'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: playlistSongDestroyActions.DESTROY_ERROR,
      })
    }
  },

  doDestroyAll: (ids) => async (dispatch) => {
    try {
      dispatch({
        type: playlistSongDestroyActions.DESTROY_ALL_STARTED,
      })

      await PlaylistSongService.destroyAll(ids)

      dispatch({
        type: playlistSongDestroyActions.DESTROY_ALL_SUCCESS,
      })

      if (listActions) {
        dispatch(listActions.doClearAllSelected())
        dispatch(listActions.doFetchCurrentFilter())
      }

      Message.success(
        i18n('entities.playlistSong.destroyAll.success'),
      )

      dispatch(push('/playlist-song'))
    } catch (error) {
      Errors.handle(error)

      dispatch(listActions.doFetchCurrentFilter())

      dispatch({
        type: playlistSongDestroyActions.DESTROY_ALL_ERROR,
      })
    }
  },
}

export default playlistSongDestroyActions
